<script lang="ts" setup>
import { onActivated, onBeforeMount, ref } from "vue";
import { CoinRankItem } from "@/types/coinRank";
import { useCoinRank } from "@/stores/coinRank";
import { useRouter } from "vue-router";
import {
  VoteTargetEntityType,
  VoteTargetType,
} from "@/composable/rank/rankConfig";
import { useGlobalUser } from "@/stores/globalUser";

const props = defineProps<{
  type: VoteTargetEntityType;
  item: VoteTargetType;
}>();

const rank = useCoinRank();
const coinRankItem = ref<CoinRankItem | null>(null);
const loading = ref(false);
const router = useRouter();
const userStore = useGlobalUser();

const prepareData = async () => {
  try {
    loading.value = true;
    if (!rank.currentCoinRank) {
      await rank.getOrFetchCurrentRank();
    }
    coinRankItem.value = await rank.fetchRankItem(
      props.type,
      props.item.id!,
      rank.currentCoinRank!.id
    );
  } finally {
    loading.value = false;
  }
};
onBeforeMount(prepareData);
onActivated(prepareData);
</script>
<template>
  <div class="border p-2 rounded flex items-center justify-between min-h-12">
    <div class="flex items-center gap-2">
      <div class="text-primary">{{ $t("rank.rankOfCurrentMonth") }}:</div>
      <span v-if="loading" class="loading loading-xs" />
      <span
        v-else-if="coinRankItem"
        class="text-primary flex items-center gap-1"
      >
        <span>No.{{ coinRankItem?.position }}</span>
      </span>
      <span v-else class="text-base-content/50">{{
        $t("rank.notRanked")
      }}</span>
    </div>
    <div class="flex items-center gap-1">
      <template v-if="loading">
        <button class="btn btn-sm rounded" disabled>
          <span class="loading loading-sm" />
        </button>
      </template>
      <template v-else-if="userStore.isLogin">
        <coin-vote :item="item" :teleport="'body'" :type="type">
          <button class="btn btn-sm rounded btn-primary">
            {{ $t("Coin.vote") }}
          </button>
        </coin-vote>
      </template>
    </div>
  </div>
</template>
